var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0074BD;}\n\t.st1{fill:#EA2D2E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    className: "st0",
    d: "M209.37,271.64c0,0-13.42,7.75,9.55,10.38c27.81,3.18,42.07,2.77,72.65-3.04 c0,0,8.03,5.12,19.37,9.41C242.16,317.86,155.4,286.72,209.37,271.64L209.37,271.64z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st0",
    d: "M200.93,233.17c0,0-15.08,11.21,7.89,13.56c29.75,3.04,53.14,3.32,93.82-4.57 c0,0,5.67,5.67,14.39,8.86C234.14,275.23,141.56,252.82,200.93,233.17L200.93,233.17z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st1",
    d: "M271.78,167.85c16.88,19.51-4.43,37.09-4.43,37.09s43.04-22.14,23.25-49.95 c-18.4-25.88-32.66-38.75,44-83.17C334.6,71.68,214.35,101.71,271.78,167.85L271.78,167.85z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    className: "st0",
    d: "M362.69,300c0,0,9.96,8.16-10.93,14.53c-39.71,12.04-165.22,15.64-199.96,0.42 c-12.45-5.4,10.93-13.01,18.4-14.67c7.75-1.66,12.04-1.38,12.04-1.38c-13.98-9.82-90.08,19.23-38.61,27.68 C283.68,349.41,399.08,316.47,362.69,300L362.69,300z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    className: "st0",
    d: "M215.87,193.31c0,0-63.79,15.22-22.56,20.62c17.44,2.35,52.03,1.8,84.41-0.97 c26.43-2.21,53-6.92,53-6.92s-9.27,4.01-16.05,8.58c-64.76,17.02-189.99,9.13-154.02-8.3C191.1,191.65,215.87,193.31,215.87,193.31 L215.87,193.31z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st0",
    d: "M330.31,257.25c65.87-34.18,35.42-67.11,14.11-62.69c-5.26,1.11-7.47,2.08-7.47,2.08 s1.94-3.04,5.67-4.29c42.07-14.81,74.45,43.59-13.56,66.7C329.06,259.04,330.03,258.08,330.31,257.25L330.31,257.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    className: "st1",
    d: "M290.59,0c0,0,36.53,36.53-34.59,92.58c-57.01,44.97-13.01,70.71,0,100.05 c-33.35-30.03-57.7-56.46-41.38-81.09C238.7,75.55,305.26,57.98,290.59,0L290.59,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st0",
    d: "M222.24,350.1c63.24,4.01,160.38-2.21,162.73-32.24c0,0-4.43,11.35-52.31,20.34 c-53.97,10.1-120.53,8.99-160.1,2.49C172.7,340.69,180.72,347.47,222.24,350.1L222.24,350.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M382.06,403.79h-1.94v-1.11h5.12v1.11h-1.94v5.4h-1.38L382.06,403.79L382.06,403.79L382.06,403.79z  M392.44,404.06L392.44,404.06l-1.94,5.12h-0.83l-1.94-5.12l0,0v5.12h-1.25v-6.5h1.8l1.8,4.57l1.8-4.57h1.8v6.5h-1.25 L392.44,404.06L392.44,404.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212,464.4c-5.95,5.12-12.32,8.03-17.99,8.03c-8.03,0-12.45-4.84-12.45-12.59c0-8.44,4.7-14.53,23.39-14.53 h6.92v19.1H212L212,464.4z M228.46,482.94v-57.43c0-14.67-8.44-24.35-28.51-24.35c-11.76,0-22.14,2.91-30.58,6.64l2.35,10.24 c6.64-2.49,15.22-4.7,23.52-4.7c11.62,0,16.61,4.7,16.61,14.39v7.33h-5.67c-28.23,0-40.96,10.93-40.96,27.4 c0,14.25,8.44,22.28,24.22,22.28c10.1,0,17.71-4.15,24.91-10.38l1.25,8.72h12.87V482.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    className: "st1",
    d: "M283.4,482.94h-20.48l-24.77-80.4h17.99l15.36,49.4l3.46,14.81 c7.75-21.45,13.28-43.31,15.91-64.21h17.44C303.46,429.11,295.16,458.17,283.4,482.94L283.4,482.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M362.14,464.4c-5.95,5.12-12.32,8.03-17.99,8.03c-8.03,0-12.45-4.84-12.45-12.59c0-8.44,4.7-14.53,23.39-14.53 H362L362.14,464.4L362.14,464.4L362.14,464.4z M378.6,482.94v-57.43c0-14.67-8.44-24.35-28.64-24.35 c-11.76,0-22.14,2.91-30.58,6.64l2.35,10.24c6.64-2.49,15.22-4.7,23.52-4.7c11.62,0,16.61,4.7,16.61,14.39v7.33h-5.81 c-28.23,0-40.96,10.93-40.96,27.4c0,14.25,8.44,22.28,24.22,22.28c10.24,0,17.71-4.15,24.91-10.38l1.25,8.72h13.15V482.94z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    className: "st1",
    d: "M147.1,496.64c-4.7,6.92-12.32,12.32-20.62,15.36l-8.16-9.55c6.37-3.18,11.76-8.44,14.25-13.28 c2.21-4.29,3.04-9.96,3.04-23.25v-91.74h17.44v90.5C153.18,482.39,151.8,489.58,147.1,496.64L147.1,496.64z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/Java.33c1bbc26f7ea5e2c82f56b2b414faed.svg";
export { ForwardRef as ReactComponent };